module.exports = {"440112001":"黄埔街道","440112002":"红山街道","440112003":"鱼珠街道","440112005":"大沙街道","440112006":"文冲街道","440112007":"穗东街道","440112008":"南岗街道","440112010":"长洲街道","440112011":"夏港街道","440112012":"萝岗街道","440112013":"云埔街道","440112014":"联和街道","440112015":"永和街道","440112016":"长岭街道","440112101":"九龙镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440112.json
// module id = 1950
// module chunks = 0